import useFetchIntegrationPropertySettings from 'hooks/useFetchIntegrationPropertySettings';
import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';

const usePropertySetting = ({
  enumId,
  propertyUid,
  pagePropertyUids,
}: {
  enumId: IntegrationEnum;
  propertyUid: string;
  pagePropertyUids: string[];
}) => {
  const { data: propertySettings, isLoading: isFetchingPropertySettings } =
    useFetchIntegrationPropertySettings({
      enumId,
      propertyUids: pagePropertyUids,
      enabled: pagePropertyUids.length > 0,
    });

  const isLoading = isFetchingPropertySettings;

  const propertySetting = propertySettings?.propertySettings.find(
    (setting) => setting.propertyUid === propertyUid,
  );

  const isIntegrationEnabled =
    propertySetting?.status === IntegrationStatus.ACTIVE;
  const isPendingStatus = propertySetting?.status === IntegrationStatus.PENDING;
  const isInactiveStatus =
    propertySetting?.status === IntegrationStatus.INACTIVE;

  return {
    propertySetting,
    isLoading,
    isIntegrationEnabled,
    isPendingStatus,
    isInactiveStatus,
  };
};

export default usePropertySetting;
